import { FormNames } from "@/constants/shared";
import { useOrganisationStore } from "@/plugins/store";

/**
 * Check if the current form is a partner link form.
 * @returns {boolean} - True if the current form is a partner link form, false otherwise.
 */
export const isPartnerLink = (): boolean => {
    const orgStore = useOrganisationStore();

    return orgStore.formName === FormNames.PARTNER_LINK;
};
